<template>
  <DialogHeader>Are you sure</DialogHeader>
  <DialogContent>
    Please confirm you would like to remove this {{ type }}. Any files you have
    added with this owner will not be affected.

    <Message v-if="error?.message" class="mt-4" type="error">
      {{ error.message }}
    </Message>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      :disabled="loading"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton
      class="w-1/2 tablet-h:w-auto"
      danger
      :disabled="loading"
      :loading="loading"
      @click="handleSave"
    >
      Yes, remove
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, Message } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import {
  CopyrightOwnersDocument,
  CopyrightOwnerType,
  useDeleteCopyrightOwnerMutation,
  type CopyrightOwner,
  type CopyrightOwnersQuery,
  type User,
} from '@/shared/graphql/legacy/generated'
import { computed } from 'vue'
import { useUserStore } from '@/shared/stores/user'
import gql from 'graphql-tag'

const { close } = useDialog()

const props = defineProps<{
  owner: CopyrightOwner
}>()

const {
  loading,
  mutate: deleteCopyrightOwner,
  error,
} = useDeleteCopyrightOwnerMutation()

const userStore = useUserStore()

const type = computed(() => {
  if (props.owner.type === CopyrightOwnerType.Personal) return 'copyright owner'
  return 'organization'
})

const handleSave = async () => {
  await deleteCopyrightOwner(
    { id: props.owner.id },
    {
      update(cache, { data }) {
        cache.updateQuery<CopyrightOwnersQuery>(
          { query: CopyrightOwnersDocument },
          (response) => {
            if (!response || !data) return

            return {
              ...response,
              copyrightOwners: {
                ...response.copyrightOwners,
                items: response.copyrightOwners.items.filter(
                  (item) => item.id !== props.owner.id
                ),
              },
            }
          }
        )

        cache.updateFragment<User>(
          {
            id: cache.identify({
              __typename: 'User',
              id: userStore.user?.id,
            }),
            fragment: gql`
              fragment DecreaseCopyrightOwnersTotal on User {
                totalCopyrightOwners
              }
            `,
          },
          (response) => {
            if (!response) return

            return {
              ...response,
              totalCopyrightOwners: Math.min(
                (response.totalCopyrightOwners || 0) - 1,
                0
              ),
            }
          }
        )
      },
    }
  )

  close()
}
</script>
